var App = App || {};

App.HomeBanner = (function ($) {
    'use strict';

    function init() {
        let vid = document.getElementById("home-banner-video");

        if ($("#home-banner-video").length == 1) {
            vid.play();
            if (!$("#home-banner-video").get(0).paused) {
                $(".home-banner__pause").show().addClass("active");
                $(".home-banner__play").hide().removeClass("active");
            }
        }


        function playVid() {
            vid.play();
            $(".home-banner__pause").show().addClass("active");
            $(".home-banner__play").hide().removeClass("active");
        }

        function pauseVid() {
            vid.pause();
            $(".home-banner__pause").hide().removeClass("active");
            $(".home-banner__play").show().addClass("active");
        }

        function scrollTop() {
            var duration = 100,
                offset = $(".home-banner").outerHeight();

            if (matchMedia("screen and (max-width: 992px)").matches) {
                var offset = $(".home-banner").outerHeight() - 200
            }

            $('html, body').stop()
                .animate({
                    scrollTop: offset
                }, duration);
        }

        $(".home-banner-video-controls .home-banner__play").on("click", function () {
            playVid();

        });

        $(".home-banner-video-controls .home-banner__pause").on("click", function () {
            pauseVid();
        });

        $(".home-banner-jump-anchor .btn-down").on("click", function () {
            scrollTop();
        })

    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.HomeBanner.init();
});